import { Route, Routes } from "react-router";
import ProtectedRoute from "./components/common/ProtectedRoute";
import MainLayout from "./components/layouts/MainLayout";
import Accounts from "./pages/Accounts";
import Profile from "./pages/Profile";
import Home from "./pages/Home";
import Login from "./pages/Login";
import AccountDocuments from "./pages/AccountDocuments";
import AccountBilling from "./pages/AccountBilling";
import Invoice from "./pages/Invoice";
import Chat from "./pages/Chat";
import Referrals from "./pages/Referrals";
import AccountCors from "./pages/AccountCors";
import AccountS2Licenses from "./pages/AccountS2Licenses";
import AccountPTRs from "./pages/AccountPTRs";
import AccountSwornDeclarations from "./pages/AccountSwornDeclarations";
import Cors from "./pages/Cors";
import CorInformation from "./pages/CorInformation";
import Invoices from "./pages/Invoices";
import AccountRDOs from "./pages/AccountRDOs";
import TaxIndexes from "./pages/TaxIndexes";
import AccountCreditables from "./pages/AccountCreditables";
import AccountReceipts from "./pages/AccountReceipts";
import Creditables from "./pages/Creditables";
import Receipts from "./pages/Receipts";
import PaymentConfirmations from "./pages/PaymentConfirmations";
import Settings from "./pages/Settings";
import AccountJournals from "./pages/AccountJournals";
import AccountReports from "./pages/AccountReports";
import UnpostedEntries from "./pages/UnpostedEntries";

function App() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="/invoice/:id" element={<Invoice />} />
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/referrals" element={<Referrals />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/accounts/:id" element={<Profile />} />
          <Route path="/accounts/billing/:id" element={<AccountBilling />} />
          <Route path="/accounts/journals/:id" element={<AccountJournals />} />
          <Route path="/accounts/reports/:id" element={<AccountReports />} />
          <Route
            path="/accounts/documents/:id"
            element={<AccountDocuments />}
          />
          <Route
            path="/accounts/:id/certificate-of-registrations"
            element={<AccountCors />}
          />
          <Route
            path="/accounts/:id/s2-licenses"
            element={<AccountS2Licenses />}
          />
          <Route
            path="/accounts/:id/professional-tax-receipts"
            element={<AccountPTRs />}
          />
          <Route
            path="/accounts/:id/sworn-declarations"
            element={<AccountSwornDeclarations />}
          />
          <Route
            path="/accounts/:id/creditables/"
            element={<AccountCreditables />}
          />
          <Route path="/accounts/:id/receipts" element={<AccountReceipts />} />
          <Route path="/account-rdos" element={<AccountRDOs />} />
          <Route path="/messages" element={<Chat />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/certificate-of-registrations" element={<Cors />} />
          <Route path="/tax-indexes" element={<TaxIndexes />} />
          <Route path="/creditables" element={<Creditables />} />
          <Route path="/receipts" element={<Receipts />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/unposted-entries" element={<UnpostedEntries />} />
          <Route
            path="/payment-confirmations"
            element={<PaymentConfirmations />}
          />
          <Route
            path="/certificate-of-registrations/:id"
            element={<CorInformation />}
          />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
